import { PricerModes } from '@pages/Pricers/enums';

import { PagesPermissions } from '../../models/Permissions/enum';

import { ICONS_TYPES } from '../Icon';

import { NavItem } from './types';

export const ButtonItems: NavItem[] = [
  {
    title: 'Home',
    path: '/home',
    icon: ICONS_TYPES.Home,
  },
  {
    title: 'Sponsor Dashboard',
    path: '/sponsor-dashboard',
    icon: ICONS_TYPES.ShieldDollar,
    permission: PagesPermissions.sponsorPage,
  },
  { title: 'SERVICES', type: 'section' },
  {
    title: 'Hedge Accounting',
    path: '/accounting-center',
    icon: ICONS_TYPES.Scale,
    subNav: [
      {
        title: 'Scheduled Deliverables',
        path: '/scheduled-deliverables',
        icon: ICONS_TYPES.Users,
        permission: PagesPermissions.scheduledDeliverables,
      },
      {
        title: 'Run Deliverables',
        path: '/run-deliverables',
        icon: ICONS_TYPES.WorldDollar,
        permission: PagesPermissions.runDeliverables,
      },
      {
        title: 'HA Mangement',
        path: '/manage-hedge-accounting',
        icon: ICONS_TYPES.TransactionDollar,
        permission: PagesPermissions.hedgeAccounting,
      },
      {
        title: 'Journal Entries',
        path: '/journal-entries',
        icon: ICONS_TYPES.Notebook,
        permission: PagesPermissions.journalEntries,
      },
      {
        title: 'HA Administration',
        path: '/ha-admin',
        icon: ICONS_TYPES.Settings,
        permission: PagesPermissions.journalEntries,
      },
    ],
  },
  {
    title: 'Fund Level',
    path: '/fund-level-center',
    icon: ICONS_TYPES.Crowdfunding,
    subNav: [
      {
        title: 'Fund Level Workflow',
        path: '/trade_notification',
        icon: ICONS_TYPES.SquareWorkflow,
        permission: PagesPermissions.tradeNotification,
      },
      {
        title: 'Fund Level Compliance',
        path: '/compliance-centre',
        icon: ICONS_TYPES.Eye,
        permission: PagesPermissions.complianceCentre,
      },
      {
        title: 'Rolling',
        path: '/transaction-rolling',
        icon: ICONS_TYPES.Exchange,
        permission: PagesPermissions.transactionRollingTool,
      },
      {
        title: 'Rebalancing',
        path: '/fund-level-center/rebalancing',
        icon: ICONS_TYPES.Scale,
        permission: PagesPermissions.exposureCapture,
      },
      {
        title: 'Cost Analysis',
        path: '/transaction-cost-analysis',
        icon: ICONS_TYPES.TrendingUp,
        permission: PagesPermissions.transactionCostAnalysis,
      },
      {
        title: 'Cash Consumption',
        path: '/fund-level-center/fl-cash-consumption',
        icon: ICONS_TYPES.Math,
        permission: PagesPermissions.flCashConsumption,
      },
      {
        title: 'Fund Settlements',
        path: '/fund-settlement',
        icon: ICONS_TYPES.SettlementDocument,
        permission: PagesPermissions.settlements,
      },
      {
        title: 'Fund Level Admin',
        path: '/fund-level-admin',
        icon: ICONS_TYPES.Settings,
        permission: PagesPermissions.fundLevelAdmin,
      },
    ],
  },
  {
    title: 'Risk Management',
    path: '/risk-management-analysis',
    icon: ICONS_TYPES.Scale,
    subNav: [
      // {
      //   title: 'RM Analysis',
      //   path: '/risk-management-analysis',
      //   icon: ICONS_TYPES.Chart,
      //   permission: PagesPermissions.riskManagementAnalysis,
      // },
      {
        title: 'IR Analysis',
        path: '/ir-analysis',
        icon: ICONS_TYPES.Math,
        permission: PagesPermissions.irAnalysis,
      },
      {
        title: 'FX Analysis',
        path: '/fx-analysis',
        icon: ICONS_TYPES.TransactionDollar,
        permission: PagesPermissions.irAnalysis,
      },
      {
        title: 'DC Analysis',
        path: '/deal-contingent-analysis',
        icon: ICONS_TYPES.Clock,
        permission: PagesPermissions.irAnalysis,
      },
    ],
  },
  { type: 'section', title: 'tools & data' },
  {
    title: 'Pricers',
    path: '/hedging-center',
    icon: ICONS_TYPES.Calculator,
    subNav: [
      {
        title: 'Interest Rate Pricer',
        path: `/hedging-center/pricer?pricerType=${PricerModes.interestRate}&type=new`,
        icon: ICONS_TYPES.IRPricer,
        permission: PagesPermissions.irPricer,
      },
      {
        title: 'Debt Pricer',
        path: '/debt/pricer?type=new',
        icon: ICONS_TYPES.Debt,
        permission: PagesPermissions.debtPricer,
      },
      {
        title: 'FX Pricer',
        path: `/hedging-center/pricer?pricerType=${PricerModes.fx}&type=new`,
        icon: ICONS_TYPES.FX,
        permission: PagesPermissions.fxPricer,
      },
      {
        title: 'Commodity Pricer',
        path: `/hedging-center/pricer?pricerType=${PricerModes.commodity}&type=new`,
        icon: ICONS_TYPES.Commodity,
        permission: PagesPermissions.commodityPricer,
      },
      {
        title: 'Inflation Pricer',
        path: `/hedging-center/pricer?pricerType=${PricerModes.inflation}&type=new`,
        icon: ICONS_TYPES.IRPricer,
        permission: PagesPermissions.inflationPricer,
      },
      {
        title: 'Custom Pricer',
        path: `/hedging-center/pricer?pricerType=${PricerModes.custom}&type=new`,
        icon: ICONS_TYPES.SettingsDollar,
        permission: PagesPermissions.customPricer,
      },
    ],
  },
  // this is appears only who has marketDataCurvesPage permission
  {
    title: 'Market Data Curves',
    path: '/market-data-curves',
    permission: PagesPermissions.marketDataCurvesPage,
    icon: ICONS_TYPES.Linechart,
  },
  {
    title: 'Market Data',
    path: '/market-curves-custom-calculations',
    permission: PagesPermissions.marketDataWidgetsPage,
    icon: ICONS_TYPES.Linechart,
    subNav: [
      {
        title: 'IR Market Data',
        path: '/ir-market-data',
        icon: ICONS_TYPES.Business,
        permission: PagesPermissions.irMarketData,
      },
      {
        title: 'FX Market Data',
        path: '/fx-market-data',
        icon: ICONS_TYPES.WorldDollar,
        permission: PagesPermissions.fxMarketData,
      },
      {
        title: 'Market Reports',
        path: '/market-reports',
        icon: ICONS_TYPES.FilePen,
        // permission: PagesPermissions.marketReportsPage,
      },
      {
        title: 'Commodity Market Data',
        path: '/commodity-market-data',
        icon: ICONS_TYPES.ReceiptDollar,
        permission: PagesPermissions.commodityMarketData,
      },
      {
        title: 'Interactive Market Data',
        path: '/market-data-curves',
        permission: PagesPermissions.marketDataCurvesPage,
        icon: ICONS_TYPES.Linechart,
      },
    ],
  },
  {
    title: 'Trades',
    path: '/trade-center',
    icon: ICONS_TYPES.TransactionDollar,
    permission: PagesPermissions.tradeCenter,
  },
  {
    title: 'Debts',
    path: '/debt-centre',
    icon: ICONS_TYPES.ReceiptDollar,
    permission: PagesPermissions.companyCenter,
  },
  {
    title: 'Settlements',
    path: '/settlements',
    icon: ICONS_TYPES.SettlementDocument,
    permission: PagesPermissions.settlements,
  },
  { type: 'section', title: 'admin & reference' },
  {
    title: 'Reports',
    path: '/report-center',
    icon: ICONS_TYPES.FilePen,
    permission: PagesPermissions.reportCenter,
  },
  {
    title: 'Companies',
    path: '/company-center',
    icon: ICONS_TYPES.Building,
    permission: PagesPermissions.companyCenter,
  },
  {
    title: 'Banks',
    path: '/banks',
    icon: ICONS_TYPES.Banks,
    permission: PagesPermissions.banks,
  },
  {
    title: 'Deals',
    path: '/deals',
    icon: ICONS_TYPES.Handshake,
    permission: PagesPermissions.deals,
  },
  {
    title: 'Deals Management',
    path: '/deals-management',
    icon: ICONS_TYPES.Warning,
    permission: PagesPermissions.dealsManagement,
  },
  // {
  //   title: 'Debts',
  //   path: '/debt-centre',
  //   icon: ICONS_TYPES.ReceiptDollar,
  //   permission: PagesPermissions.companyCenter,
  // },
  {
    title: 'Users',
    path: '/users',
    icon: ICONS_TYPES.Users,
    permission: PagesPermissions.users,
  },
  {
    title: 'Settings',
    icon: ICONS_TYPES.Settings,
    subNav: [
      {
        title: 'User Role',
        path: '/user-role',
        icon: ICONS_TYPES.PinFilled,
        permission: PagesPermissions.manageAccessControl,
      },
    ],
  },
];
